import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { ServicePortfolio } from './components/ServicePortfolio';
import { ProjectGallery } from './components/ProjectGallery';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { MaintenanceTips } from './components/MaintenanceTips';
import { CtaBanner } from './components/CtaBanner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FloatingActions } from './components/FloatingActions';
interface AppProps {
  /** Show the home maintenance tips education section. */
  showMaintenanceTips?: boolean;
  /** Show the sticky WhatsApp / call / back-to-top action stack. */
  showFloatingActions?: boolean;
}
export function App({
  showMaintenanceTips = true,
  showFloatingActions = true
}: AppProps) {
  return <LanguageProvider data-id="element-0" data-mp="3mk86mzi0yde2">
      <div className="w-full bg-white" data-id="element-1" data-mp="3mjq3diwy2ywn">
        <Navbar data-id="element-2" data-mp="3rcj846sey78q" />
        <main data-id="element-3" data-mp="3rbznujfaj6rj">
          <Hero data-id="element-4" data-mp="3rdkie91luppe" />
          <TrustBar data-id="element-5" data-mp="3rd1all5o5hp3" />
          <Services data-id="element-6" data-mp="3relv0hy9rk98" />
          <WhyChooseUs data-id="element-7" data-mp="5opiv1o0k3w" />
          <ServicePortfolio data-id="element-8" data-mp="4wxfu7a14id" />
          <ProjectGallery data-id="element-9" data-mp="56m9egl55mh" />
          <Process data-id="element-10" data-mp="2zl3bdjx5744s" />
          <Testimonials data-id="element-11" data-mp="2zllcouynw8jk" />
          {showMaintenanceTips ? <MaintenanceTips data-id="element-12" data-mp="2zmwhmy3ufmc9" /> : null}
          <CtaBanner data-id="element-13" data-mp="33mf1dqjxhrdi" />
          <Contact data-id="element-14" data-mp="33lx0uhq8gqzs" />
        </main>
        <Footer data-id="element-15" data-mp="33mykhalbelt4" />
        {showFloatingActions ? <FloatingActions data-id="element-16" data-mp="38m1fe27kzbnd" /> : null}
      </div>
    </LanguageProvider>;
}